import React, {useEffect, useMemo, useState} from "react";
import server from "../../../server";
import AssetDashboardView from "./asset-dashboard.view";
import {getOverdueFromAssetCount} from "./actions/asset-dashboard.action";
import type {AssetsCount} from "../../../domains/models/asset-management";
import type {AllocationOverdueData} from "./types/asset-dashboard.type";
import '../../../styles/component/asset/asset-dashboard.scss';

const initialAssetsCount: AssetsCount = {
    assetCount: {
        categories: [
            {
                id: "",
                name: "",
                assets: 0,
                inStock: 0,
                inUse: 0,
                missing: 0,
                underMaintenance: 0,
                disposed: 0,
                overdue: 0,
                returned: 0,
            },
        ],
        summary: {
            total: 0,
            available: 0,
            allocated: 0,
            underMaintenance: 0,
            disposed: 0,
            missing: 0,
            overdue: 0,
            returned: 0,
        }
    },
    costAnalysis: {
        categories: [
            {
                allocated: 0,
                assetCount: 0,
                available: 0,
                id: "",
                name: "",
                disposed: 0,
                missing: 0,
                total: 0,
                underMaintenance: 0,
                categoryShare: 0
            }
        ],
        summary: {
            total: 0,
            allocated: 0,
            available: 0,
            missed: 0,
            underMaintenance: 0,
            disposed: 0,
            allocatedPercentage: 0,
            availablePercentage: 0,
            missedPercentage: 0,
            underMaintenancePercentage: 0,
            disposedPercentage: 0
        }
    },
    requestAnalysis: {
        categories: [
            {
                id: "",
                name: "",
                total: 0,
                accepted: 0,
                rejected: 0,
                pending: 0,
                cancelled: 0,
                allocated: 0,
            }
        ],
        summary: {
            accepted: 0,
            cancelled: 0,
            pending: 0,
            rejected: 0,
            total: 0,
            allocated: 0,
            acceptedPercentage: 0.0,
            allocatedPercentage: 0.0,
            rejectedPercentage: 0.0,
            pendingPercentage: 0.0,
            cancelledPercentage: 0.0
        }
    }
}

const AssetDashboard = () => {
    const [assetsCount, setAssetsCount] = useState<AssetsCount>(initialAssetsCount);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getAssetsCount().then((r: AssetsCount) => setAssetsCount(r));
    }, []);

    async function getAssetsCount(): Promise<AssetsCount> {
        setLoading(true);
        try {
            return await server.asset.analysis("2010-01-01", new Date().toISOString().slice(0, 10));
        } catch (e) {
            console.error("Error while fetching data", e);
            return initialAssetsCount;
        } finally {
            setLoading(false);
        }
    }

    const {chartData, totalOverdue}: AllocationOverdueData = useMemo(() => {
        return getOverdueFromAssetCount(assetsCount);
    }, [assetsCount]);

    return (
        <AssetDashboardView
            loading={loading}
            assetsCount={assetsCount}
            allocationOverdueData={{chartData, totalOverdue}}
        />
    )
}

export default AssetDashboard;